<template>
  <div class="pt_scroll_item">
    <div class="pt_scroll_itemL">
      <div class="pt_scroll_item_img">
        <van-image
          width="38"
          height="38"
          lazy-load
          round
          :src="item.participantImg"
        >
        <template v-slot:loading>
          <div class="loadingbg"></div>
        </template>
        <template v-slot:error>
          <div class="loadingbg"></div>
        </template>
        </van-image>
      </div>
      <div class="pt_scroll_item_name">{{item.participantNickname}}</div>
      <div class="pt_scroll_item_info">
        <p>还差{{item.freeCount}}人成团</p>
        <div class="countD">
          <div class="countDTxt">剩余</div>
          <van-count-down :time="item.expectEndTime" format="HH:mm:ss" />
        </div>
      </div>
    </div>
    <div class="pt_scroll_itemR"><div @click="gotoJoinGroup(item)">去参团</div></div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import defaultImg from "@/assets/images/default.png"
export default {
  name: '',
  components:{

  },
  props: {
    item:{
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  data () {
    return {
      title: '',
      defaultImg: defaultImg
    }
  },
  computed: {
    ...mapState({
      isLogin: (state)=> state.user.isLogin,
      shopNum: (state)=> state.shopcar.shopNum,
  }),
  },
  methods: {
    gotoJoinGroup(group){
      this.$emit("gotoJoinGroup",group)
    }
  }
}
</script>
<style scoped lang='less'>
.pt_scroll_item{
  height: 1.28rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pt_scroll_item:first-child {
  margin-top: 0;
  transition: margin-top .8s;
}
.pt_scroll_con{
  padding: 0 0.5333rem;
}
.pt_scroll_con .pt_scroll_item{
  height: 1.6rem;
}
.pt_scroll_itemL{
  display: flex;
  align-items: center;
}
.pt_scroll_item_img img{
  width: 1.0133rem;
  height: 1.0133rem;
}
.pt_scroll_item_name{
  width: 1.8133rem;
  margin-right: 0.24rem;
  margin-left: 0.2133rem;
  font-size:0.3733rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  line-height: 1.4;
  word-break: break-all;
  color: rgba(0, 0, 0, 0.86);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.pt_scroll_item_info p{
  height:0.4533rem;
  font-size:0.32rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(0,0,0,0.86);
  line-height:0.4533rem;
}
.countD{
  font-size:0.32rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(248,79,36,1);
  display: flex;
  align-items: center;
  margin-top: 0.0533rem;
}
.countDTxt{
  margin-right: 0.0667rem;
}
.pt_scroll_itemR div{
  width:2.08rem;
  height:0.7467rem;
  border-radius:0.4rem;
  border:1px solid rgba(248,79,36,0.7);
  font-size:0.3733rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(248,79,36,1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pt_scroll_con .pt_scroll_itemR div{
  width:2.08rem;
  height:0.7467rem;
  border-radius:0.4rem;
  border:1px solid rgba(248,79,36,0.7);
  background:rgba(250,99,57,1);
  font-size:0.3733rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:#fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pt_scroll_count{
  height:1.0933rem;
  font-size:0.2667rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.van-count-down {
  color: rgba(248,79,36,1);
  font-size:0.32rem;
}
.loadingbg{
  width: 100%;
  height: 100%;
  background: url('../../assets/images/default.png') no-repeat;
  background-size: 100% 100%;
}
</style>